/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RedeemerDefinitionDto } from '../models';
import { RedeemerErrorArchivePagedResponse } from '../models';
import { RedeemerTransactionPagedResponse } from '../models';
import { ResolutionPost } from '../models';
/**
 * RedeemerTransactionApi - axios parameter creator
 * @export
 */
export const RedeemerTransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionArchivedGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/archived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (showResolved !== undefined) {
                localVarQueryParameter['showResolved'] = showResolved;
            }

            if (showUnresoved !== undefined) {
                localVarQueryParameter['showUnresoved'] = showUnresoved;
            }

            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionDeleteDelete: async (server?: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [playerId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionGetForPlayerGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, playerId?: string, searchTerm?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/getForPlayer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (playerId !== undefined) {
                localVarQueryParameter['playerId'] = playerId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isAdhoc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionGetGet: async (server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, isAdhoc?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isAdhoc !== undefined) {
                localVarQueryParameter['isAdhoc'] = isAdhoc;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionGrantPost: async (body?: RedeemerDefinitionDto, playerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (playerId !== undefined) {
                localVarQueryParameter['PlayerId'] = playerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionMultiPlayerGrantPost: async (body?: RedeemerDefinitionDto, playerIds?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/multiPlayerGrant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (playerIds !== undefined) {
                localVarQueryParameter['playerIds'] = playerIds;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionResolvePost: async (body?: ResolutionPost, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [transactionId] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedeemerTransactionReverseGrantPost: async (transactionId?: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/RedeemerTransaction/reverseGrant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['TransactionId'] = transactionId;
            }

            if (server !== undefined) {
                localVarQueryParameter['Server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedeemerTransactionApi - functional programming interface
 * @export
 */
export const RedeemerTransactionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionDeleteDelete(server, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [playerId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGetForPlayerGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, playerId?: string, searchTerm?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RedeemerTransactionPagedResponse>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionGetForPlayerGet(server, page, itemsPerPage, sortBy, sortDesc, playerId, searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isAdhoc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, isAdhoc?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RedeemerTransactionPagedResponse>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, isAdhoc, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGrantPost(body?: RedeemerDefinitionDto, playerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionGrantPost(body, playerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionMultiPlayerGrantPost(body?: RedeemerDefinitionDto, playerIds?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionMultiPlayerGrantPost(body, playerIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionResolvePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [transactionId] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionReverseGrantPost(transactionId?: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await RedeemerTransactionApiAxiosParamCreator(configuration).apiRedeemerTransactionReverseGrantPost(transactionId, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RedeemerTransactionApi - factory interface
 * @export
 */
export const RedeemerTransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [showResolved] 
         * @param {boolean} [showUnresoved] 
         * @param {string} [languageCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionDeleteDelete(server, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [playerId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGetForPlayerGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, playerId?: string, searchTerm?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RedeemerTransactionPagedResponse>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionGetForPlayerGet(server, page, itemsPerPage, sortBy, sortDesc, playerId, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [itemsPerPage] 
         * @param {string} [sortBy] 
         * @param {boolean} [sortDesc] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isAdhoc] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, isAdhoc?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<RedeemerTransactionPagedResponse>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, isAdhoc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionGrantPost(body?: RedeemerDefinitionDto, playerId?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionGrantPost(body, playerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RedeemerDefinitionDto} [body] 
         * @param {string} [playerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionMultiPlayerGrantPost(body?: RedeemerDefinitionDto, playerIds?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionMultiPlayerGrantPost(body, playerIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResolutionPost} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionResolvePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [transactionId] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedeemerTransactionReverseGrantPost(transactionId?: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return RedeemerTransactionApiFp(configuration).apiRedeemerTransactionReverseGrantPost(transactionId, server, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedeemerTransactionApi - object-oriented interface
 * @export
 * @class RedeemerTransactionApi
 * @extends {BaseAPI}
 */
export class RedeemerTransactionApi extends BaseAPI {
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [searchTerm] 
     * @param {boolean} [showResolved] 
     * @param {boolean} [showUnresoved] 
     * @param {string} [languageCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionArchivedGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, showResolved?: boolean, showUnresoved?: boolean, languageCode?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RedeemerErrorArchivePagedResponse>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionArchivedGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, showResolved, showUnresoved, languageCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionDeleteDelete(server?: string, id?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionDeleteDelete(server, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [playerId] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionGetForPlayerGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, playerId?: string, searchTerm?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RedeemerTransactionPagedResponse>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionGetForPlayerGet(server, page, itemsPerPage, sortBy, sortDesc, playerId, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [itemsPerPage] 
     * @param {string} [sortBy] 
     * @param {boolean} [sortDesc] 
     * @param {string} [searchTerm] 
     * @param {boolean} [isAdhoc] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionGetGet(server?: string, page?: number, itemsPerPage?: number, sortBy?: string, sortDesc?: boolean, searchTerm?: string, isAdhoc?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<RedeemerTransactionPagedResponse>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionGetGet(server, page, itemsPerPage, sortBy, sortDesc, searchTerm, isAdhoc, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RedeemerDefinitionDto} [body] 
     * @param {string} [playerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionGrantPost(body?: RedeemerDefinitionDto, playerId?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionGrantPost(body, playerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {RedeemerDefinitionDto} [body] 
     * @param {string} [playerIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionMultiPlayerGrantPost(body?: RedeemerDefinitionDto, playerIds?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionMultiPlayerGrantPost(body, playerIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ResolutionPost} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionResolvePost(body?: ResolutionPost, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionResolvePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [transactionId] 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedeemerTransactionApi
     */
    public async apiRedeemerTransactionReverseGrantPost(transactionId?: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return RedeemerTransactionApiFp(this.configuration).apiRedeemerTransactionReverseGrantPost(transactionId, server, options).then((request) => request(this.axios, this.basePath));
    }
}
